import { openBlock as o, createBlock as f, Transition as T, withCtx as h, withDirectives as v, createElementVNode as l, normalizeClass as g, createElementBlock as c, toDisplayString as s, createCommentVNode as r, createTextVNode as m, vShow as x } from "vue";
/* empty css                    */
import _ from "./design-system.es128.js";
const d = 5e3, k = 14, C = {
  name: "DsToast",
  props: {
    actionText: {
      type: String,
      default: ""
    },
    headline: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    action: Function
  },
  emits: ["after-leave"],
  data() {
    return {
      active: !1,
      timeout: d,
      timer: null
    };
  },
  computed: {
    calculatedTimeout() {
      let { timeout: i } = this;
      return i === d && (this.action && (i += 3e3), this.headline && (i += 2e3)), i;
    },
    hasLongActionText() {
      return this.action && this.actionText.length > k;
    }
  },
  mounted() {
    this.active = !0, this.timer = setTimeout(() => {
      this.close();
    }, this.calculatedTimeout);
  },
  beforeUnmount() {
    clearTimeout(this.timer);
  },
  methods: {
    close() {
      this.active = !1;
    }
  }
}, y = {
  key: 0,
  class: "toast-headline"
};
function A(i, t, e, N, u, n) {
  return o(), f(T, {
    name: "fade",
    onAfterLeave: t[2] || (t[2] = (a) => i.$emit("after-leave"))
  }, {
    default: h(() => [
      v(l("div", {
        class: g(["toast", { "has-action": e.action, stacked: n.hasLongActionText }]),
        onClick: t[1] || (t[1] = (...a) => n.close && n.close(...a))
      }, [
        l("div", null, [
          e.headline ? (o(), c("div", y, s(e.headline), 1)) : r("", !0),
          m(" " + s(e.message), 1)
        ]),
        t[3] || (t[3] = m()),
        e.action ? (o(), c("a", {
          key: 0,
          class: "toast-action",
          onClick: t[0] || (t[0] = (...a) => e.action && e.action(...a))
        }, s(e.actionText), 1)) : r("", !0)
      ], 2), [
        [x, u.active]
      ])
    ]),
    _: 1
  });
}
const D = /* @__PURE__ */ _(C, [["render", A], ["__scopeId", "data-v-9b046294"]]);
export {
  D as default
};
//# sourceMappingURL=design-system.es3.js.map
